'use client';

export const getMultiplan = (type?: 'U_M' | '_M') => {
  if (type) {
    return `MULTIPLAN_COVERRIGHT_2027${type}`
  }

  if (typeof document !== "undefined") {
    if (['plan.coverrightmedicare.com', 'plan-test.coverright.com'].includes(document.location.host)) {
      return 'MULTIPLAN_COVERRIGHT_2027_M'
    }
  }

  return 'MULTIPLAN_COVERRIGHT_2027U_M'
}
